module.exports = __webpack_public_path__ + "img/-LV4xdUAvIjGWKvMTpjT.f4b37431.jpg";